<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="{ ...$attrs, class: null, maxlength: null }" :maxlength="maxlength" class="form-input" :class="{ error: error }" :type="type" :value="modelValue" @input="emailValidation($event)" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `email-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'email',
    },
    error: String,
    label: String,
    modelValue: [String, Number],
    maxlength: {
      type: Number,
      default: 255,
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(newValue, oldValue) {
      if(typeof(oldValue) != "undefined") {
        if(newValue.length != (oldValue.length - 1) && newValue.length != (oldValue.length + 1)) {
          newValue = '';
        }
      }
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    emailValidation(e){
      e.target.value = this.$filters.allowedChars(e.target.value, true, true);
      this.$emit('update:modelValue', e.target.value)
    },
  },
}
</script>
